import block from 'bem-cn-lite';
import {FC} from 'react';
import {Text} from '@gravity-ui/uikit';
import {Link} from 'react-router-dom';

import './NavigationMobileMenu.scss';

const b = block('navigation-mobile-menu-main-header');

interface NavigationMobileMenuProps {
    isOpen: boolean;
    onToggle: () => void;
    onOpenContacts: () => void;
}

export const NavigationMobileMenu: FC<NavigationMobileMenuProps> = ({
    isOpen,
    onToggle,
    onOpenContacts
}) => {
    return (
        <div className={b({open: isOpen})}>
            <ul className={b('list')}>
                <li className={b('item')}>
                    <Link to={'/home'} className={b('link')} onClick={onToggle}>
                        <Text variant="header-2">Главная</Text>
                    </Link>
                </li>
                {/* <li className={b('item')}>
                    <Link to={'/catalog'} className={b('link')} onClick={onToggle}>
                        <Text variant="header-2">Каталог</Text>
                    </Link>
                </li> */}
                <li className={b('item')}>
                    <Link to={'/basket'} className={b('link')} onClick={onToggle}>
                        <Text variant="header-2">Корзина</Text>
                    </Link>
                </li>
                <li className={b('item')}>
                    <Link to={'/orders'} className={b('link')} onClick={onToggle}>
                        <Text variant="header-2">Заказы</Text>
                    </Link>
                </li>
                <li className={b('item')}>
                    <Link to={'/balance'} className={b('link')} onClick={onToggle}>
                        <Text variant="header-2">Баланс</Text>
                    </Link>
                </li>
                <li className={b('item')}>
                    <Link to={'/profile'} className={b('link')} onClick={onToggle}>
                        <Text variant="header-2">Профиль</Text>
                    </Link>
                </li>
                <li className={b('item')}>
                    {/* Пробуем другой вариант, закомментированный пока не удалять */}
                    {/* <div className={b('link')} onClick={onOpenContacts}>
                        <Text variant="header-2">Контакты</Text>
                    </div> */}
                    <Link to={'/profile/contacts'} className={b('link')} onClick={onToggle}>
                        <Text variant="header-2">Контакты</Text>
                    </Link>
                </li>
            </ul>
        </div>
    );
};
